import React from 'react';
import SubmitButton from './../../components/SubmitButton/index';
import {InfoMessage} from '../../components/Messages/index';

const PickupForm = ({onSubmit, inactive, email = '', submitTitle, warningMessage}) => {
    const handleSubmit = () => {
    onSubmit({email});
  };
  const getDisableError = () => {
    let disableError = '';

    if (inactive) {
      disableError = 'Please select your available hours';
    }

    return disableError;
  }
  return (
    <div className='pickup-form'>
        <div className='form-controls'>
          {warningMessage && <InfoMessage logger title={warningMessage} />}
          <SubmitButton
            disableError={getDisableError() || warningMessage}
                  title={submitTitle || 'CONFIRM APPOINTMENT'}
            onClick={handleSubmit}
          />
        </div>
    </div>
  );
}

export default PickupForm;